import { Box, Step, StepButton, Stepper, Typography } from '@mui/material'
import { useAppDispatch, useAppSelector } from '../../../redux/hook'
import {
    EntityStep,
    setRelationStepData,
    updateActiveEntityStep,
    updateActiveFirstLevelStep,
    updateEntitySteps,
} from '../../../redux/slices/entityInstanceSlice'
import theme from '../../../theme/theme'
import { useAttributesStepValidation } from '../../../utils/attributeValidations'
import { EntityStepTypes } from '../../../constants/constants'
import { useTranslation } from 'react-i18next'

const Steps: React.FC = () => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()
    const { validateSteps } = useAttributesStepValidation()
    const path = useAppSelector((state) => state.entityInstance.path)
    const entitySteps = useAppSelector(
        (state) => state.entityInstance.entitySteps,
    )
    const activeEntityStep = useAppSelector(
        (state) => state.entityInstance.activeEntityStep,
    )
    const hasStartStep = useAppSelector(
        (state) => state.entityInstance.hasStartStep,
    )

    const handleStep = (step: number) => () => {
        dispatch(updateActiveEntityStep(step))
        if (path?.length === 1) {
            dispatch(updateActiveFirstLevelStep(step))
        }
    }

    const handleRelationStep = (step: number) => () => {
        const { isValidate, validatedSteps } = validateSteps(entitySteps)
        if (isValidate) {
            dispatch(updateActiveEntityStep(step))
            if (path?.length === 1) {
                dispatch(updateActiveFirstLevelStep(step))
            }
            dispatch(setRelationStepData(step))
        } else {
            dispatch(updateEntitySteps(validatedSteps))
            dispatch(updateActiveEntityStep(hasStartStep ? 1 : 0))
            if (path?.length === 1) {
                dispatch(updateActiveFirstLevelStep(hasStartStep ? 1 : 0))
            }
        }
    }

    return (
        <Box>
            {entitySteps?.length > 1 ? (
                <Box
                    sx={{
                        marginBottom: '20px',
                        padding: '0px 10px',
                    }}
                >
                    <Stepper nonLinear activeStep={activeEntityStep}>
                        {entitySteps?.map((label: EntityStep, index: any) => (
                            <Step
                                key={index}
                                sx={{
                                    minWidth: '100px',
                                    opacity: label.disabled ? '0.5' : '1',
                                }}
                                disabled={label.disabled}
                            >
                                <StepButton
                                    color="inherit"
                                    onClick={
                                        label?.stepType ===
                                            EntityStepTypes.Attributes ||
                                        label?.stepType ===
                                            EntityStepTypes.Start_step
                                            ? handleStep(index)
                                            : handleRelationStep(index)
                                    }
                                    className="entity-steps-tabs"
                                    icon={<></>}
                                    id={`step-${label.step}`}
                                >
                                    <Box display="flex" alignItems="center">
                                        <Box
                                            sx={{
                                                // width: '25px',
                                                // height: '25px',
                                                padding: '3px 4px',
                                                minWidth: '18px',
                                                color: '#fff',
                                                fontSize: '12px',
                                                background:
                                                    label.stepNo - 1 ===
                                                    activeEntityStep
                                                        ? theme.palette.primary
                                                              .main
                                                        : '#00000061',
                                                borderRadius: '50%',
                                                display: 'flex !important',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginRight: '10px',
                                            }}
                                        >
                                            {t(label.step)}
                                        </Box>
                                        <Box
                                            display="flex"
                                            flexDirection="column"
                                            alignItems="flex-start"
                                            marginLeft="5px"
                                            minWidth="50px"
                                        >
                                            <Typography
                                                sx={{
                                                    fontSize: '12px',
                                                    marginBottom: '5px',
                                                    marginTop: '-3px',
                                                }}
                                            >
                                                {t('step')} {label.step}
                                            </Typography>
                                            <Typography
                                                sx={{
                                                    fontSize: '14px',
                                                    fontWeight: 600,
                                                    textWrap: 'nowrap',
                                                }}
                                            >
                                                {t(label.relationName)}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </StepButton>
                            </Step>
                        ))}
                    </Stepper>
                </Box>
            ) : (
                <></>
            )}
        </Box>
    )
}
export default Steps
